import AppCatalog from "@/services/App/AppCatalog.js";

export default {
  Message: {
    Details_ParamIncomplete:
      AppCatalog.Message.ParamIncomplete,
    Edit_ParamIncomplete:
      AppCatalog.Message.ParamIncomplete
  }
}